import styled, { css } from '@xstyled/emotion';
import { breakpoints } from '@xstyled/system';
import { Text } from '@oms/ui-text';

export const Key = styled(Text)`
  color: label;
  font-size: xs;
  text-transform: uppercase;

  ${breakpoints({
    md: css`
      white-space: nowrap;
    `,
  })}
`;
Key.defaultProps = {
  fontWeight: 'bold',
};

export const Label = styled(Key)``;
Label.defaultProps = {
  as: 'label',
  fontWeight: 'bold',
};

export const Value = styled(Text)``;

export const Result = styled(Text)`
  font-size: 3xl;
`;

export const ResultCurrency = styled(Text)`
  font-size: small;
  align-self: flex-start;
`;

export const Form = styled.form`
  display: flex;
  flex: 1;
  padding: 4 4 0 4;
  margin: 0;
  ${breakpoints({
    base: css`
      flex-direction: column;
      & > * {
        margin-bottom: 4 !important;
      }
    `,
    md: css`
      flex-direction: row;
      align-items: flex-end;
      & > * + * {
        margin-left: 4;
      }
    `,
  })}
`;
